/*global chrome*/
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { Store } from "react-notifications-component";
import axios from "axios";
//
import VersionUpdatePromptModal from "../../common/VersionUpdatePromptModal";
import { getKeycloackToken } from "../../../../../redux/actions/auth";
import Connection from "../../../../../images/connection.png";
import { extractVersionFromBlobName, notificationPopUp } from "./../../util";
import { getSuperAgent } from "../../../../../redux/actions/user";
// import Connection from "../../../../../images/check-green.png";

const StepTwo = ({
  stepTwo,
  stepTwoToggle,
  stepThreeToggle,
  stepFourToggle,
}) => {
  const [blobURL, setBlobURL] = useState({});
  const [latestBlobVersion, setLatestBlobVersion] = useState();
  const [versionCheckModal, setVersionCheckModal] = useState(false);
  const [connectionMsg, setConnectionMsg] = useState(false);
  const showConnectModal = useSelector((state) => state.skillReducer.isActive);

  const dispatch = useDispatch();

  useEffect(() => {
    downloadExeFile();
  }, []);

  async function downloadExeFile() {
    let token = await getKeycloackToken();
    axios
      .get(`${process.env.REACT_APP_BOT_SERVICE_URL}/download`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (res) => {
        const {
          data: { url, blobName },
        } = res;
        setBlobURL(url);
        setLatestBlobVersion(blobName);
        dispatch(getSuperAgent(url));
      })
      .catch((e) => console.log(e));
  }

  const verifyVersion = async () => {
    let token = await getKeycloackToken();
    let conf = {
      method: "GET",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/user/retrieveSession`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const sessionRes = await axios(conf);
    let _agentVersion =
      sessionRes?.data?.uniqueDevices[0]?.meta_data?.desktopVersion;

    if (sessionRes?.data?.uniqueDevices?.length && _agentVersion !== "") {
      const latestStudioVersion = extractVersionFromBlobName(latestBlobVersion);
      if (_agentVersion !== latestStudioVersion) {
        setVersionCheckModal(true);
      } else {
        stepThreeToggle(false);
        stepFourToggle(true);
      }
    } else {
      window.open(blobURL, "_self");

      stepThreeToggle(true);
    }
  };

  const checkChromeExtension = () => {
    try {
      chrome.runtime.sendMessage(
        process.env.REACT_APP_CHROME_TAB_ID,
        { type: "ping" },
        (response) => {
          if (!response) {
            notificationPopUp();
          } else {
            if (showConnectModal === "connectWeb") {
              setConnectionMsg(true);
            } else {
              verifyVersion();
            }
          }
        }
      );
    } catch (error) {
      notificationPopUp();
    }
  };

  return (
    <>
      <Modal className="cdModal" isOpen={stepTwo}>
        <ModalBody>
          {" "}
          <div className="cdm-block cdm-second-step ">
            <div className="col-md-4 col-sm-4 cdm-list">
              <div className="cdm-list-1">
                <ul>
                  <li className="active">
                    <a href="#">
                      <div className="cdm-list-ico">
                        <img src={Connection} alt="" />
                      </div>
                      <p className="cdm-list-title">Enable Extension</p>
                    </a>
                  </li>
                  {showConnectModal === "connectWindow" ? (
                    <>
                      <li>
                        <a href="#">
                          <div className="cdm-list-ico">
                            <img src={Connection} alt="" />
                          </div>
                          <p className="cdm-list-title">
                            Install Super Assistant For Windows
                          </p>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <div className="cdm-list-ico">
                            <img src={Connection} alt="" />
                          </div>
                          <p className="cdm-list-title">
                            Connection Successful
                          </p>
                        </a>
                      </li>{" "}
                    </>
                  ) : null}
                </ul>
              </div>
            </div>
            {connectionMsg == true ? (
              <div className="col-md-8 col-sm-8">
                <div className="cdm-content">
                  <h4 className="cdm-title">
                    Your device is connected successfully.
                  </h4>
                  <div className="center-spinner">
                    <div className="cdm-ico">
                      <img src={Connection} alt="" />
                    </div>
                  </div>
                  <div className="cdm-btns">
                    <button
                      onClick={() => {
                        stepTwoToggle(false);
                      }}
                      className="btn btn-sm btn-primary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-md-8 col-sm-8">
                <div className="cdm-content">
                  <h4 className="cdm-title">Enable Chrome extension</h4>
                  <p>
                    Chrome extension enables Super Assistant to create or
                    execute web based automations.
                  </p>
                  <p>
                    <a
                      target={"_blank"}
                      rel="noreferrer"
                      href={`https://chrome.google.com/webstore/detail/super/${process.env.REACT_APP_CHROME_TAB_ID}`}
                    >
                      Click here
                    </a>{" "}
                    to open extension page in a new tab if not opened
                    automatically.
                  </p>
                  <div className="cdm-btns">
                    <button
                      onClick={() => {
                        stepTwoToggle(false);
                      }}
                      className="btn btn-sm btn-danger"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    {showConnectModal === "connectWindow" ? (
                      <button
                        onClick={() => {
                          checkChromeExtension();
                        }}
                        className="btn btn-sm btn-primary"
                      >
                        I enabled it
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      {showConnectModal === "connectWindow" ? (
        <>
          {" "}
          {versionCheckModal && (
            <VersionUpdatePromptModal
              setVersionCheckModal={setVersionCheckModal}
              blobURL={blobURL}
              stepThreeToggle={stepThreeToggle}
              stepFourToggle={stepFourToggle}
            />
          )}{" "}
        </>
      ) : null}
    </>
  );
};

export default StepTwo;
